import {create} from 'zustand';
import {UseFormChangeDataStoreProps} from './types';
import {DEFAULT_FORM_DATA} from './constants';

export const useFormChangeDataStore = create<UseFormChangeDataStoreProps>(set => ({
	form: DEFAULT_FORM_DATA,
	setForm: form => set({form}),
	reset: () => set({form: DEFAULT_FORM_DATA}),
}));
